/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviousAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaIconArrowBack from 'DesignSystem/Svgs/TysiaIconArrowBack/index'



/** @type {import('Simple/types.js').View} */
export default function PreviousAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PreviousAction",
  onClickPrevAction,
  prevActionDisabled
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClickPrevAction}
 size="small"
 type="ghost"
 marginRight={dtSpaceXxs}
 title="Previous"
 disabled={prevActionDisabled}
>
{childProps => (
<TysiaIconArrowBack
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowBack`}
 width={12}
 height={12}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}